import React, { Component } from 'react';
import './MyScreenerPopup.css';
import PopupTitleBar from './PopupTitleBar';
import Config from '../../Configs/criteria.json';

const NUMBER_OF_SCREENER = Config.myscreener.maxnum;

export default class MyScreenerPopup extends Component {
    constructor(props) {
        super(props);
    
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
        this.state = {
            current: 0
        };
    }
    closePopupHandler = () => {
        this.props.closePopup();
    }
    handleSelectBox = (num) => (e) => {
        this.setState( {current: num} );
        if (this.props.data[num].name!=="") {
            this.myRef.current.value = this.props.data[num].name;
            this.myRef2.current.value = this.props.data2[num].criteria;
        } else {
            this.myRef.current.value = Config.myscreener.defaultnameprefix + (num+1);
            this.myRef2.current.value = "";

        }
    }
    handleSaveScreener = () => {
        if(this.myRef.current.value===""||this.myRef.current.value===" "){
            this.myRef.current.value=Config.myscreener.defaultnameprefix + (this.state.current+1);
        }
        this.props.onSaveScreener(this.state.current, this.myRef.current.value,this.myRef2.current.value);
    }
    generateMyScreenerBox = () => {
        let row = [];
        let boxes = [];
        
        for (let i=0; i<NUMBER_OF_SCREENER; i++) {            
            boxes.push(<div className={"myscreenerbox" + ((i===this.state.current)?" selected":"")} onClick={this.handleSelectBox(i)}><div className="number">{"0"+(i+1)}</div><p className="name">{this.props.data[i].name===""?Config.myscreener.notregtext:this.props.data[i].name}</p></div>);
            if ((i+1)%3===0) {
                row.push(<div>{boxes}</div>);
                row.push(<div style={{clear: "both"}} />);
                boxes = [];
            }
        }
        return row;
    }
    componentDidMount() {
        let tmpCurrent=0;
        if(this.props.presetSelected.substr(0,1)==="c"){
            tmpCurrent=this.props.presetSelected.substr(2,3)-1;
            // console.log("current:"+tmpCurrent+"||"+this.props.presetSelected.substr(2,3));
        }
        if (this.props.data[tmpCurrent].name!=="") {
            this.setState({current:tmpCurrent});
            this.myRef.current.value = this.props.data[tmpCurrent].name;
            this.myRef2.current.value = this.props.data2[tmpCurrent].criteria;
        } else {
            this.myRef.current.value = Config.myscreener.defaultnameprefix + "1";
            this.myRef2.current.value = "";
        }
    }
     onKeyPress = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    };  
    render() {
        return (
            <div className={this.props.appId==="Hyper"?"MyScreenerPopup Hyper":"MyScreenerPopup"}>
                <PopupTitleBar title="Myスクリーナーに保存" closePopup={this.closePopupHandler} />
                <div className="container">
                    <div className="title">保存先を選択</div>
                    { this.generateMyScreenerBox() }
                    <div className="inputtext">スクリーナー名を入力 (最大15文字)</div>
                    <div className="inputbox"><input type="text" maxlength='15' ref={this.myRef}></input></div>
                    <div className="inputtext">メモを入力 (最大100文字)</div>
                    <div className="inputboxmemo"><textarea onKeyDown={this.onKeyPress} maxlength='100' ref={this.myRef2}></textarea></div>
                    <div className="inputnote">・ブラウザのキャッシュをクリアすると（cookieを削除）、保存内容は削除されます。</div>
                    <div className="inputnote">・Myスクリーナーの保存内容は、アプリ連携はされません。</div>
                    <div className="save" onClick={this.handleSaveScreener}>保存</div>
                </div>
            </div>
        )
    }
}